"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyOtpChallengeRepository = void 0;
const resolver_1 = require("./resolver");
const mapper_1 = require("./mapper");
exports.verifyOtpChallengeRepository = {
    verify: async (api, progressId, data) => {
        const response = await (0, resolver_1.fetchVerifyOtp)(api, progressId, data);
        return (0, mapper_1.mapVerifyOtpToChallenge)(response.data);
    },
};
//# sourceMappingURL=repository.js.map